var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.nextServiceCommunication)?_c('li',{attrs:{"data-testId":"nextServiceCommunication"}},[_vm._v("\n    "+_vm._s(_vm.$t('coupon.nextApptBookNotif', {
            date: _vm.nextServiceCommunicationDate,
            service: _vm.nextServiceCommunicationServiceName
        }))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }